// 購入を始めた画面の情報。購入の結果は PurchaseResultHandler が 1 か所で受け取り、これでトーストの文言を決める

export enum PurchaseAudience {
  /** 子どもの画面（プランの案内・マイページのプラン）。文言は MSG_USER_PLAN_PURCHASE_* */
  CHILD = "child",
  /** 保護者のページ（プランのタブ・メッセージ）。文言は parent の MSG_SUBSCRIPTION_PURCHASE_* */
  PARENT = "parent",
}

// Stripe へ移ってから戻るまで持ち越す
const STORAGE_KEY = "purchase_context";

let current: PurchaseAudience | null = null;

export const setPurchaseAudience = (audience: PurchaseAudience) => {
  current = audience;
  try {
    sessionStorage.setItem(STORAGE_KEY, audience);
  } catch {
    // 持ち越せないときは、戻ったときに子ども向けの文言になるだけ
  }
};

/** 始めた画面を取り出して消す。分からないときは子ども向け */
export const takePurchaseAudience = (): PurchaseAudience => {
  let audience = current;
  try {
    audience = audience ?? (sessionStorage.getItem(STORAGE_KEY) as PurchaseAudience | null);
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage が使えないときは、覚えている分だけ使う
  }
  current = null;
  return audience === PurchaseAudience.PARENT ? PurchaseAudience.PARENT : PurchaseAudience.CHILD;
};
